import { WalletAddressFormCta } from 'BreetComponents';
import { useWithdrawUsdRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

import { useWithdrawRequestUsdFormStageContext } from '../../FormStageContext';

const FormWalletAddressActions = ({ variant = 'default' }: { variant?: 'default' | 'save-address' }) => {
	const { navigator } = useWithdrawRequestUsdFormStageContext();
	const { formDataContextProps, resetWalletAddressProps } = useWithdrawUsdRequestContext();

	const onSavedWalletAddress = useCallback(() => {
		if (variant === 'save-address') {
			navigator.reset();
		}

		navigator.goTo(variant === 'default' ? 'crypto-transaction-details' : 'withdraw-funds')();
	}, [navigator, variant]);

	return (
		<WalletAddressFormCta
			formDataContextProps={formDataContextProps}
			onSavedWalletAddress={onSavedWalletAddress}
			onScanWalletAddress={navigator.goTo('scan-wallet-address')}
			resetWalletAddressProps={resetWalletAddressProps}
			variant={variant}
		/>
	);
};

export default FormWalletAddressActions;
